import styled from 'styled-components'
import globals from '../globals'

const quantityCols = 12
const { huge, large, medium, small, extraSmall } = globals.mediaqueries;
// caso seja adicionado mais media queries, 
// também existem referencias à esses breakpoints
// no arquivo src/components/globals.js
// favor atualizar em ambos os lugares

export const Row = styled.div`
  display: flex;
  box-orient: horizontal;
  box-direction: normal;
  flex-flow: row wrap;

  margin-left: ${props => props.gutter ? `-${props.gutter / 2}px` : '-15px'};
  margin-right: ${props => props.gutter ? `-${props.gutter / 2}px` : '-15px'};
  
  & > .col {
    padding-left: ${props => props.gutter ? `${props.gutter / 2}px` : '15px'};
    padding-right: ${props => props.gutter ? `${props.gutter / 2}px` : '15px'};

    & > .col-inner {
      padding: ${props => props.gutter ? `${props.gutter / 2}px` : `15px`};
    }
  }

  
`

const percentage = size => {
  return `${size / quantityCols * 100}%`
}

const searchForFallbacks = (responsiveObject, mediaQuery) => {
  const fallbacks = {
    huge: ['extraSmall', 'small', 'medium', 'large'],
    large: ['extraSmall', 'small', 'medium'],
    medium: ['extraSmall', 'small'],
    small: ['extraSmall']
  }
  
  if( responsiveObject[mediaQuery] || mediaQuery === 'extraSmall' ){
    return responsiveObject[mediaQuery] || quantityCols
  } else {

    let number = quantityCols
    for (let index = 0; index < fallbacks[mediaQuery].length; index++) {
      const breakpoint = fallbacks[mediaQuery][index];
      if(responsiveObject[breakpoint]){
        number = responsiveObject[breakpoint]
      }
    }

    return number    
  }  
}

const colCalc = (responsiveObject, mediaQuery) => {
  const mq = mediaQuery || 'extraSmall'
  return (
    responsiveObject ? 
      percentage( 
        searchForFallbacks( responsiveObject, mq )
      ) : '100%'
  );
}

export const Col = styled.div`
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: block;

  @media ${extraSmall}{
    flex: 0 0 ${props => colCalc(props.responsive, 'extraSmall')};
    max-width: ${props => colCalc(props.responsive, 'extraSmall')};
  }

  @media ${small}{
    flex: 0 0 ${props => colCalc(props.responsive, 'small')};
    max-width: ${props => colCalc(props.responsive, 'small')};
  }

  @media ${medium}{
    flex: 0 0 ${props => colCalc(props.responsive, 'medium')};
    max-width: ${props => colCalc(props.responsive, 'medium')};
  }

  @media ${large}{
    flex: 0 0 ${props => colCalc(props.responsive, 'large')};
    max-width: ${props => colCalc(props.responsive, 'large')};
  }

  @media ${huge}{
    flex: 0 0 ${props => colCalc(props.responsive, 'huge')};
    max-width: ${props => colCalc(props.responsive, 'huge')};
  }


`